import { createSvgIcon } from "@mui/material";

const CancelDialogIcon = createSvgIcon(
  <svg viewBox="0 0 80 80" fill="none">
    <path
      d="M0 21.3333C0 9.55126 9.55126 0 21.3333 0H58.6667C70.4487 0 80 9.55126 80 21.3333V58.6667C80 70.4487 70.4487 80 58.6667 80H21.3333C9.55126 80 0 70.4487 0 58.6667V21.3333Z"
      fill="var(--subtle-surface-bg, #F6F8FA)"
    />
    <path
      d="M42.6342 65.3499C54.3691 65.3499 63.8822 55.8369 63.8822 44.102C63.8822 32.367 54.3691 22.854 42.6342 22.854C30.8993 22.854 21.3862 32.367 21.3862 44.102C21.3862 55.8369 30.8993 65.3499 42.6342 65.3499Z"
      fill="#F3D0D1"
    />
    <path
      d="M15.0068 39.5069C15.0068 36.2925 15.7458 33.1066 16.8454 30.4188C17.1706 29.6237 18.0789 29.2429 18.874 29.5681C19.6691 29.8934 20.0504 30.8016 19.7252 31.5967C18.7573 33.9625 18.118 36.7489 18.1179 39.5069C18.1179 50.4777 27.0694 59.4292 38.0403 59.4292C42.605 59.4292 46.7625 57.8389 50.2 55.2608C50.8873 54.7453 51.8625 54.8847 52.3779 55.572C52.8933 56.2593 52.754 57.2345 52.0667 57.75L51.6974 58.0217C47.8532 60.7987 43.1868 62.5403 38.0403 62.5403C25.3512 62.5403 15.0068 52.196 15.0068 39.5069Z"
      fill="#F44336"
    />
    <path
      d="M57.9619 39.5085C57.9619 28.5377 49.0105 19.5862 38.0396 19.5862C33.262 19.5862 28.7782 21.3935 25.353 24.1765C24.6862 24.7182 23.7064 24.6171 23.1646 23.9504C22.6229 23.2836 22.7244 22.3037 23.3912 21.762C27.3166 18.5726 32.4805 16.4751 38.0396 16.4751C50.7287 16.4751 61.073 26.8195 61.073 39.5085C61.073 42.3348 60.5804 45.0497 59.5926 47.6426C59.2867 48.4453 58.3879 48.8482 57.5852 48.5424C56.7825 48.2365 56.3797 47.3378 56.6855 46.535C57.5353 44.3042 57.9619 41.9654 57.9619 39.5085Z"
      fill="#F44336"
    />
    <path
      d="M43.9425 31.4063C44.55 30.7988 45.5347 30.7988 46.1422 31.4063C46.7497 32.0138 46.7497 32.9984 46.1422 33.6059L32.1391 47.609C31.5316 48.2164 30.547 48.2164 29.9395 47.609C29.332 47.0015 29.332 46.0168 29.9395 45.4093L43.9425 31.4063Z"
      fill="#F44336"
    />
    <path
      d="M29.9395 31.4063C30.547 30.7988 31.5317 30.7988 32.1392 31.4063L46.1422 45.4093L46.1977 45.4675C46.7493 46.0781 46.7306 47.0205 46.1422 47.609C45.5537 48.1974 44.6113 48.2161 44.0007 47.6645L43.9425 47.609L29.9395 33.6059C29.332 32.9985 29.332 32.0138 29.9395 31.4063Z"
      fill="#F44336"
    />
  </svg>,
  "CancelDialogIcon"
);

export default CancelDialogIcon;
